import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import ShiftTimePicker from '../ShiftTimePicker';
import CustomModal from '../../../../../../../components/Modal/CustomModal';
import { CleanIcon } from '../../../../../../../components/buttons/IconButtons';
import ButtonIcon from '../../../../../../../components/buttons/ButtonIcon';
import { errorMsg } from '../../../../../../../Apis/functions';
import HandleChange from '../../../../../../../Helpers/HandleChange';
import {DEPARTMENT_POLICY_MODEL} from "../Model/Model";
import {CreateAttendanceDepartment} from "../../../../../../../reduxToolkit/EmployeePayRoll/EmployeePayRollApi";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param show - Boolean to determine if the "Add New Workshift" modal should be shown
 * @param onHide - Function to hide the modal when triggered
 * @param setModified - Function to set the created status flag after adding a new workshift
 * @param {number|string|null} departmentId - Identifier of the department used to conditionally display or manage policy creation
 */
const CreateDepartmentPolicy = ({ show, onHide, setModified, departmentId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [selectedList, setSelectedList] = useState([]);
    const [emptyFields, setEmptyFields] = useState(false);
    const [item, setItem] = useState({ ...DEPARTMENT_POLICY_MODEL });
    const { handleChange : baseHandleChange } = HandleChange({ model: item, setModel: setItem });
    const [isValidRange, setIsValidRange] = useState(true);

    /**
     * Handles the creation of a new department policy.
     * Validates required fields and shift range before sending the request.
     * If successful, resets the form and closes the modal.
     */
    const handleCreate = () => {
        if (!item.isValid() || !isValidRange) {
            setEmptyFields(true);
            return;
        }

        dispatch(CreateAttendanceDepartment(item.toAddEdit(selectedList))).then(
            ({
                payload: {
                    data: { success, code },
                },
            }) => {
                if (success === true) {
                    setModified(true);
                    setItem({ ...DEPARTMENT_POLICY_MODEL });
                    setSelectedList([]);
                    onHide();
                    toast.success(t('has_been_created_successfully'));
                } else errorMsg(code);
            },
        );
    };

    /**
     * Clears all form fields and resets component state to initial values.
     * Used when the user clicks the "clean/reset" button.
     */
    const clearField = () => {
        setItem({ ...DEPARTMENT_POLICY_MODEL });
        setSelectedList([]);
        setEmptyFields(false);
    };

    /**
     * Handles input changes from form fields.
     * Normalizes the value before updating the model state.
     */
    const handleChange = (e) => {
        const { name, value } = e.target;

        baseHandleChange({
            target: {
                name,
                value: item.normalizeValue(name, value),
            },
        });
    };

    /**
     * Validates shift time range whenever relevant fields change.
     * Updates the state that controls whether the shift range is valid.
     */
    useEffect(() => {
        setIsValidRange(item?.validateShifts());
    }, [
        item?.startShiftAt,
        item?.endShiftAt,
        item?.extensionDays
    ]);
    return (
        <CustomModal
            show={show}
            onHide={onHide}
            onConfirm={handleCreate}
            title='create'
            size='lg'
            buttonConfirm='confirm'
            cancelButton={true}
            confirmButton={true}
            classNameBody="pt-2"
        >
            <div className='d-flex justify-content-end mb-3'>
                <ButtonIcon
                    className='btn-clean-secondary-600'
                    id='btn_cnr_clean'
                    Icon={CleanIcon}
                    iconProps='btn-icon-svg-12px icon-color-general-00'
                    title={'clear_instances'}
                    onClick={clearField}
                />
            </div>
            <div className='row px-0'>
                <ShiftTimePicker
                    item={item}
                    displayNone={departmentId === null}
                    emptyFields={emptyFields}
                    handleChange={handleChange}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    isValidRange={isValidRange}
                />
            </div>
        </CustomModal>
    );
};

export default CreateDepartmentPolicy;
